// Transforms a local australian number to an international format.
export const transformLocalAustralianMobileNumber = (mobileNumber: string) => {
  const trimmed = mobileNumber.replace(/[^\d\+]/g, "");
  return trimmed.replace(/^0/, "+61");
};
